import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { OrganizationSubscription } from '../../../models/subscription';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

/**
 * Add-on subscriptions for the current organization.
 *
 * Keyed by organizationId for the same reason as useSubscription: the request is scoped by
 * the `X-Organization-ID` header, so an unkeyed cache hands one organization's add-ons to
 * another after a switch.
 */
export const useAddonSubscriptions = () => {
  const organizationId = useAppSelector(
    (state: RootState) => state.organization.organizationId,
  );

  return useQuery<OrganizationSubscription[]>({
    queryKey: ['addonSubscriptions', organizationId],
    queryFn: () => subscriptionService.getAddonSubscriptions(),
    enabled: !!organizationId,
  });
};
